import { Icon } from "@chakra-ui/react";

import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";

import Toolbar from "react-big-calendar/lib/Toolbar";

import "react-big-calendar/lib/css/react-big-calendar.css";

const handleDayChange = (event, mconte) => {
  mconte(event.target.value);
};

export const CustomToolbar = (startDate) => {
    return class BaseToolBar extends Toolbar {
      constructor(props) {
        super(props);
      }

      handleNavigate = (detail, elem) => {
        detail.navigate(elem, startDate);
      };

      render() {
        
        return (
          <div className="rbc-toolbar">
            {
              this.props.view === "day"
                ?     
                  <span className="rbc-btn-group">
                    <button onClick={()=>{ this.props.onNavigate("DATE", startDate) }}>Start</button>                    
                    <button onClick={()=>this.handleNavigate(this, "PREV")}><Icon as={MdKeyboardArrowLeft}/></button>
                    <button onClick={()=>this.handleNavigate(this, "NEXT")}><Icon as={MdKeyboardArrowRight}/></button>
                    <button onClick={()=>this.handleNavigate(this, "TODAY")}>Today</button>
                  </span>
                :
                  []
            }
            <div className="rbc-toolbar-label">{this.props.label}</div>
            <span className="rbc-btn-group">
              <button 
                className={this.props.view === "day" ? "rbc-active" : ""} 
                value="day" 
                onClick={(e)=>handleDayChange(e, this.view)}
              >
                Single Day
              </button>
              <button
                className={this.props.view === "weekdays" ? "rbc-active" : ""}
                value="weekdays" 
                onClick={(e)=>{
                  this.props.onNavigate("DATE", startDate); 
                  handleDayChange(e, this.view);
                }}
              >
                All Days
              </button>
            </span>   
          </div>       
        );
      }
    };
  };
  